module.exports = __webpack_public_path__ + "img/elvis-frog-promo_ru.71c5cdbb.jpg";